import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../components/Auth/Login';

function LoginPage() {
  const navigate = useNavigate();

  const handleSwitchToRegister = () => {
    navigate('/register');
  };

 const handleLoginSuccess = (user) => {
  const isNewUser = !!user.newuser; 
  const feature = user.features;
  console.log(isNewUser);
  if (feature === "smartscan") {
    navigate('/sorter'); 
  } else if(feature === "smartlist") {
    navigate('/dashboard');
  }
  else{
    navigate('/dashboard');
  }
};


  return (
    <div>
      <Login 
        onSwitchToRegister={handleSwitchToRegister}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
}

export default LoginPage;